import CryptoJS from 'crypto-js';

class AesUtils {
    private readonly password;
    private readonly aesOptions: any;
    constructor() {
        this.password = CryptoJS.enc.Utf8.parse(CryptoJS.SHA256(window.navigator.userAgent).toString());
        this.aesOptions = {
            iv: CryptoJS.enc.Utf8.parse('abcdef0123456789'),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        };
    }

    public Encrypt(encryptText: string): string {
        try {
            return CryptoJS.AES.encrypt(encryptText, this.password, this.aesOptions).toString();
        } catch (e) {
            console.error(e);
            return '';
        }
    }
    public Decrypt(decryptText: string): string {
        try {
            return CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(decryptText, this.password, this.aesOptions));
        } catch (e) {
            console.error(e);
            return '';
        }
    }

    public utf8ToHex(str: string): string {
        const encoder = new TextEncoder();
        const bytes = encoder.encode(str);
        // 把每个字节转成两位十六进制字符串，拼接起来
        return Array.from(bytes)
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');
    }

    public hexToUtf8(hex: string): string {
        // 将十六进制字符串分割成字节数组
        const matched = hex.match(/[\da-f]{2}/gi);
        const bytes = new Uint8Array(matched ? matched.map((h) => parseInt(h, 16)) : []);
        // 使用 TextDecoder 把字节数组解码成 UTF-8 字符串
        const decoder = new TextDecoder();
        return decoder.decode(bytes);
    }
}

export default new AesUtils();
